{
  "AGENT_BOTS": {
    "HEADER": "Botlar",
    "LOADING_EDITOR": "Editör Yükleniyor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "Sistem",
    "AVATAR": {
      "SUCCESS_DELETE": "Bot avatarı başarıyla silindi",
      "ERROR_DELETE": "Bot avatarı silinirken hata oluştu, lütfen tekrar deneyin"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot Adı",
        "PLACEHOLDER": "Botunuza bir ad verin.",
        "ERROR": "Bot adı zorunludur."
      },
      "DESCRIPTION": {
        "LABEL": "Bot açıklaması",
        "PLACEHOLDER": "Bu bot ne iş yapar?"
      },
      "BOT_CONFIG": {
        "ERROR": "Lütfen yukarıdaki bot yapılandırmanızı girin.",
        "API_ERROR": "CSML yapılandırmanız geçersiz. Lütfen düzeltin ve tekrar deneyin."
      },
      "SUBMIT": "Doğrula ve kaydet"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Bir temsilci botu seçin",
      "DESC": "Gelen kutunuza bir temsilci Botu atayın. Küçük konuşmaları ele alabilir ve gerekli olduğunda canlı bir temsilciın devralmasını sağlayabilirler.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Güncelle",
      "DISCONNECT": "Botu bağlantısını kes",
      "SUCCESS_MESSAGE": "Temsilci botu başarıyla güncellendi.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Temsilci botu başarıyla bağlantısı kesildi.",
      "ERROR_MESSAGE": "Temsilci botu güncellenemedi. Lütfen tekrar deneyin.",
      "DISCONNECTED_ERROR_MESSAGE": "Temsilci botu bağlantısı kesilemedi. Lütfen tekrar deneyin.",
      "SELECT_PLACEHOLDER": "Bot seçin",
      "COUNTRY_BOTS": {
        "TITLE": "Ülkeye göre botlar",
        "DESC": "Bu gelen kutusu birden fazla ülkeye hizmet verir. Konuşma, kendi ülkesinin botuna gider: Kaufland mağazasına, Allegro siparişinin pazar yerine veya bunlar yoksa alıcının yazdığı dile göre. Diğer tüm konuşmalar yukarıdaki varsayılan bota gider.",
        "COUNTRY": "Bir ülke seçin",
        "BOT": "Bir bot seçin",
        "ADD": "Ülke için bot ekle",
        "REMOVE": "Kaldır",
        "DEFAULT_REQUIRED": "Önce bir varsayılan bot seçin. Bir ülkenin botu onun yerini yalnızca o ülke için alır.",
        "DISCONNECT_ALL": "Tüm botların bağlantısını kes"
      }
    },
    "ADD": {
      "TITLE": "Yeni botu yapılandır",
      "CANCEL_BUTTON_TEXT": "İptal Et",
      "API": {
        "SUCCESS_MESSAGE": "Bot başarıyla eklendi.",
        "ERROR_MESSAGE": "Bot eklenemedi. Lütfen daha sonra tekrar deneyin."
      }
    },
    "LIST": {
      "404": "Bot bulunamadı. 'Yeni botu yapılandır' düğmesine tıklayarak bir bot oluşturabilirsiniz ↗",
      "LOADING": "Botlar alınıyor...",
      "TABLE_HEADER": {
        "DETAILS": "Bot Ayrıntıları",
        "URL": "Web Kanca URL'si"
      },
      "TYPE": "Bot türü"
    },
    "DELETE": {
      "BUTTON_TEXT": "Sil",
      "TITLE": "Botu sil",
      "CONFIRM": {
        "TITLE": "Silmeyi Onayla",
        "MESSAGE": "{name} silmek istediğinizden emin misiniz?",
        "YES": "Evet, Sil",
        "NO": "Hayır, Tut"
      },
      "SUBMIT": "Sil",
      "CANCEL_BUTTON_TEXT": "İptal Et",
      "DESCRIPTION": "Bu botu silmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
      "API": {
        "SUCCESS_MESSAGE": "Bot başarıyla silindi.",
        "ERROR_MESSAGE": "Bot silinemedi. Lütfen tekrar deneyin."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Düzenle",
      "LOADING": "Botlar alınıyor...",
      "TITLE": "Botu düzenle",
      "CANCEL_BUTTON_TEXT": "İptal Et",
      "API": {
        "SUCCESS_MESSAGE": "Bot başarıyla güncellendi.",
        "ERROR_MESSAGE": "Bot güncellenemedi. Lütfen tekrar deneyin."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Bot avatarı"
      },
      "NAME": {
        "LABEL": "Bot adı",
        "PLACEHOLDER": "Bot adını girin"
      },
      "DESCRIPTION": {
        "LABEL": "Açıklama",
        "PLACEHOLDER": "Bu bot ne yapar?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Web Kanca URL'si",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "Bot adı gereklidir",
        "URL": "Web Kanca URL'si gereklidir",
        "VALID_URL": "Lütfen http:// veya https:// ile başlayan geçerli bir URL girin"
      },
      "CANCEL": "İptal",
      "CREATE": "Bot Oluştur",
      "UPDATE": "Bot Güncelle"
    },
    "TYPES": {
      "WEBHOOK": "Webhook botu",
      "CSML": "CSML botu"
    }
  }
}
